import { sortSelectStyles } from "@insite/content-library/Widgets/ProductList/ProductListSortSelect";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

Object.assign(sortSelectStyles, {
    ...sortSelectStyles,
    select: {
        labelProps: {
            css: css`
                text-transform: uppercase;
                font-size: 14px;
                text-align: left;
                width: 75px;
                display: table;
                padding: 11px 0 0 13px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            padding: 11px 0 0 0;
                        `,
                        null,
                        null,
                        null,
                        null,
                    ])}
            `,
        },
        cssOverrides: {
            formField: css`
                align-items: baseline;
                > div {
                    width: calc(100% - 70px);
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [null, null, null, null, null])}
                }
                select {
                    @media (max-width: 1199px) and (min-width: 992px) {
                        font-size: 13px !important;
                        padding: 0 4px 0 4px !important;
                    }
                    font-size: 14px !important;
                    height: 26px;
                    + span {
                        width: 20px !important;
                        height: 20px !important;
                        padding: 0 !important;
                    }
                }
            `,
        },
    },
});
